const currentFaceplateType = (state = {}, action) => {
    switch (action.type) {
        case 'SET_ACTIVE_FACEPLATE_TYPE':
            return {
                ...state,
                activeFaceplateType: action.payload
            };
        default:
            return state;
    }
};

export default currentFaceplateType;
